import { createContext } from 'react';

export type DropdownState = {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  toggle: () => void;
};

export const DropdownContext = createContext({} as DropdownState);
